/**
 * 中英文表单校验器
 */
export const createNumberAndEnglishValidator = ({
  minLength = 0,
  maxLength = Infinity,
  errorText = '请输入',
  allowEmpty = false,
} = {}) => {
  return function numberAndEnglishValidator(rule: any, value: any) {
    if (!value) {
      return allowEmpty ? Promise.resolve() : Promise.reject(errorText);
    }

    const regex = /^[a-zA-Z0-9]+$/;
    if (!regex.test('' + value)) {
      return Promise.reject(new Error('只能包含数字和英文'));
    }

    if (value.length < minLength) {
      return Promise.reject(`最小 ${minLength} 字符，仅限英文/数字`);
    }

    if (value.length > maxLength) {
      return Promise.reject(`最大 ${maxLength} 字符，仅限英文/数字`);
    }

    return Promise.resolve();
  };
};

/**
 * 手机号码校验器
 */
export const createPhoneValidator = ({
  allowEmpty = true,
  emptyText = '请输入联系电话',
  errorText = '请输入正确的联系电话',
} = {}) => {
  return function phoneValidator(rule: any, value: any) {
    const regex = /^\+?([0-9]{1,3}\s?)?\(?[0-9]{3}\)?[\s.-]?[0-9]{3}[\s.-]?[0-9]{4}$/;
    if (!value) {
      return allowEmpty ? Promise.resolve() : Promise.reject(emptyText);
    }
    if (regex.test('' + value)) {
      return Promise.resolve(true);
    }
    return Promise.reject(errorText);
  };
};

/**
 * 小数点校验器
 */
export const createFloatNumberValidator = ({
  allowEmpty = true,
  integerDigits = 8,
  decimalDigits = 2,
  emptyText = '请输入',
}) => {
  return function floatNumberValidator(rule: any, value: any) {
    if (!value) {
      return allowEmpty ? Promise.resolve() : Promise.reject(emptyText);
    }

    const [integerPart, decimalPart] = value?.toString()?.split('.');

    if (integerPart.length > integerDigits) {
      return Promise.reject(`整数位最大支持 ${integerDigits} 位`);
    }

    if (decimalPart && decimalPart.length > decimalDigits) {
      return Promise.reject(`小数位最大支持${decimalDigits} 位`);
    }

    return Promise.resolve();
  };
};
